// TODO: This file is temportay, will change this after mapping tags to categories in db
export const forumTagsConstant = [
  {
    label: 'Category',
    value: [
      {
        id: 1,
        name: 'Bug'
      },
      {
        id: 19,
        name: 'Question'
      },
      {
        id: 23,
        name: 'Idea'
      }
    ]
  },
  {
    label: 'General Topic',
    value: [
      {
        id: 18,
        name: 'Business Metric'
      },
      {
        id: 17,
        name: 'Data Query'
      },
      {
        id: 15,
        name: 'Data Schema'
      }
    ]
  },
  {
    label: 'Data Portal',
    value: [
      {
        id: 8,
        name: 'Dashboard'
      },
      {
        id: 9,
        name: 'Golden Query'
      },
      {
        id: 10,
        name: 'Data Catalog'
      },
      {
        id: 11,
        name: 'Query Pad'
      },
      {
        id: 12,
        name: 'Help Page'
      },
      {
        id: 25,
        name: 'Forum'
      }
    ]
  },
  {
    label: 'Platform',
    value: [
      {
        id: 3,
        name: 'Tableau'
      },
      {
        id: 4,
        name: 'Snowflake'
      },
      {
        id: 6,
        name: 'Google Sheet'
      },
      {
        id: 16,
        name: 'Airflow DAG'
      },
      {
        id: 5,
        name: 'Superset'
      },
      {
        id: 24,
        name: 'ML Portal'
      }
    ]
  }
]
